export const state = () => ({
  status: 'connecting',
  sessionState: 'inprogress',
  chatSession: '',
  isInLiveChatSession: false,
  waitingAgentStatus: 'none',
  queuePosition: 0,
  departments: [],
});

export const getters = {
  isOnline(state) {
    return state.status === 'connected';
  },
  isLoading(state) {
    return state.status === 'connecting';
  },
  isLostConnection(state) {
    // happen when : visitor is banned, intermitten connection, etc *tidak disebutkan apa etc nya di doc
    return state.status === 'closed';
  },
  isSessionEnded(state) {
    return state.sessionState === 'ended';
  },
  isInLiveChatSession(state) {
    return state.isInLiveChatSession;
  },
  isWaitingAgent(state) {
    return state.waitingAgentStatus === 'queue';
  },
  isAgentAcceptTicket(state) {
    return state.waitingAgentStatus === 'taken';
  },
  isAgentFounded(state) {
    return state.waitingAgentStatus === 'found-agent';
  },
  chatSession(state) {
    const chatSessionFromLS = localStorage.getItem('mitra-chat-current-session');
    return state.chatSession || chatSessionFromLS;
  },
  botDepartmentId(state) {
    const botDepName = 'Bot Department';
    const matchedDep = state.departments.find(dep => dep.name === botDepName);
    if (matchedDep) return matchedDep.id;
    return null;
  },
  mitraDepartmentId(state) {
    const botDepName = 'Mitra Bukalapak';
    const matchedDep = state.departments.find(dep => dep.name === botDepName);
    if (matchedDep) return matchedDep.id;
    return null;
  },
  queuePosition(state) {
    return state.queuePosition;
  },
};

export const mutations = {
  setStatus(state, status) {
    state.status = status;
  },
  setSessionState(state, sessionState) {
    if (sessionState === 'ended') localStorage.removeItem('mitra-chat-current-session');
    state.sessionState = sessionState;
  },
  setChatSession(state, payload) {
    localStorage.setItem('mitra-chat-current-session', payload);
    state.chatSession = payload;
  },
  setWaitingAgentStatus(state, status) {
    state.waitingAgentStatus = status;
  },
  removeChatSession(state) {
    localStorage.removeItem('mitra-chat-current-session');
    state.chatSession = '';
  },
  setDepartments(state, payload) {
    state.departments = payload;
  },
  setInLiveChatSession(state, isInLiveChatSession) {
    state.isInLiveChatSession = isInLiveChatSession;
  },
  setQueuePosition(state, position) {
    state.queuePosition = position;
  }
};

export const actions = {
  setStatus({ commit }, status) {
    commit('setStatus', status);
  },
  endSession({ commit }) {
    commit('setSessionState', 'ended');
  },
  setChatSession({ commit }, payload) {
    commit('setChatSession', payload);
  },
  setWaitingAgentStatus({ commit }, state) {
    commit('setWaitingAgentStatus', state);
  },
  removeChatSession({ commit }) {
    commit('removeChatSession');
  },
  setDepartments({ commit }, payload) {
    commit('setDepartments', payload);
  },
  setInLiveChatSession({ commit }, isInLiveChatSession) {
    commit('setInLiveChatSession', isInLiveChatSession);
  },
  setQueuePosition({ commit }, position) {
    commit('setQueuePosition', position);
  }
};
